import Api from "../../utils/axios";

export const RoleApi = {
  getAllRoles: (payload, search = "") =>
    Api.post(`master/get-all-role?search=${search}`, payload),
  getRoleById: (id) => Api.get(`master/get-role-by-id/${id}`),
  createRole: (payload) => Api.post("master/create-role", payload),
  updateRole: (payload, id) => Api.put(`master/update-role/${id}`, payload),
};

export const PermissionApi = {
  getAllPermissions: (payload, search = "") =>
    Api.post(`master/get-all-permission?search=${search}`, payload),
  getAllPermissionsData: () => Api.get(`master/get-all-active-permission`),
  getPermissionById: (id) => Api.get(`master/get-permission-by-id/${id}`),
  createPermission: (payload) => Api.post("master/create-permission", payload),
  updatePermission: (payload, id) =>
    Api.put(`master/update-permission/${id}`, payload),
};

export const ComponentTypeApi = {
  getAllComponentTypes: (payload, search = "") =>
    Api.post(`master/get-all-component-type?search=${search}`, payload),
  getAllComponentTypesData: () => Api.get(`master/get-active-component-type`),
  getComponentTypeById: (id) => Api.get(`master/get-component-type/${id}`),
  createComponentType: (payload) =>
    Api.post("master/create-component-type", payload),
  updateComponentType: (payload, id) =>
    Api.put(`master/update-component-type/${id}`, payload),
};

export const ComponentApi = {
  getAllComponents: (payload, search = "") =>
    Api.post(`master/get-all-component?search=${search}`, payload),
  getComponentById: (id) => Api.get(`master/get-component/${id}`),
  createComponent: (payload) => Api.post("master/create-component", payload),
  updateComponent: (payload, id) =>
    Api.put(`master/update-component/${id}`, payload),
  getActiveComponents: () => Api.get("master/get-active-component"),
  getAllComponentGetMethod: () => Api.get("master/get-all-component-list"),
};

export const RolePermissionApi = {
  getAllRolePermissions: (payload, search = "") =>
    Api.post(`master/get-all-role-permission?search=${search}`, payload),
  getRolePermissionById: (id) => Api.get(`master/get-role-permission/${id}`),
  createRolePermission: (payload) =>
    Api.post("master/create-role-permission", payload),
  updateRolePermission: (payload, id) =>
    Api.put(`master/update-role-permission/${id}`, payload),
};
